<template>
  <v-container>
    <v-row>
        <v-col>
            <h3 class="text-h4 text-center" v-if="!hasWorkspace">Create an account to begin...</h3>
            <h3 class="text-h4 text-center" v-else-if="!newWorkspaceWizard">Select an account to begin...</h3>
            <h3 class="text-h4 text-center" v-else>New workspace</h3>
        </v-col>
    </v-row>
    <v-row class="d-flex justify-center" v-if="!newWorkspaceWizard">
      <v-col cols="12" md="3" v-for="workspace in workspaces" :key="workspace.uuid">
        <v-card max-width="320" max-height="300">
          <v-img v-if="workspace.type==='Business'" 
            height="240"
            style="cursor: pointer"
            src="@/assets/profiles/Business.jpg"
            @click="onWorkspaceSelect(workspace)">
          </v-img>
          <v-img v-else-if="workspace.type==='Joint'" 
            height="240"
            style="cursor: pointer"
            src="@/assets/profiles/Joint.jpg"
            @click="onWorkspaceSelect(workspace)">
          </v-img>
          <v-img v-else 
            height="240"
            style="cursor: pointer"
            src="@/assets/profiles/Personal.jpg"
            @click="onWorkspaceSelect(workspace)">
          </v-img>
          <v-card-title class="my-auto mx-auto mr-0 pr-0">
            <v-row no-gutters>
              <v-col class="text-h5" cols="10">
                {{ workspace.name | truncate15 }}
              </v-col>
              <v-col class="d-flex justify-end pt-1 pr-0" cols="2">
                <v-menu bottom left>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn x-small text v-bind="attrs" v-on="on" class="">
                    <v-icon>{{icons.mdiDotsVertical}}</v-icon>
                  </v-btn>
                </template>
                <v-list flat>
                  <v-list-item @click="onWorkspaceRename(workspace)">
                    <v-icon class="mr-2" v-text="icons.mdiPencil"></v-icon>
                    <v-list-item-content>Rename</v-list-item-content>
                  </v-list-item>
                  <v-list-item @click="onWorkspaceDownload(workspace)">
                    <v-icon class="mr-2" v-text="icons.mdiDownload"></v-icon>
                    <v-list-item-content>Download</v-list-item-content>
                  </v-list-item>
                  <v-list-item @click="onWorkspaceDelete(workspace)">
                    <v-icon class="mr-2" v-text="icons.mdiDelete"></v-icon>
                    <v-list-item-content>Delete</v-list-item-content>
                  </v-list-item>
                </v-list>
              </v-menu>
              </v-col>
            </v-row>

          </v-card-title>
        </v-card>
      </v-col>
      <v-col cols="12" md="3">
        <v-card min-height="300" class="d-flex" color="lighten-2" style="cursor: pointer" elevation="0">
          <v-card-title class="my-auto mx-auto text-h4">
              <v-menu>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn x-small text v-bind="attrs" v-on="on" class="">
                    <v-icon x-large>mdi-plus</v-icon>
                  </v-btn>
                </template>
                <v-list flat>
                  <v-list-item @click="onCreateNewWorkspace()">
                    <v-icon class="mr-2" v-text="icons.mdiFilePlusOutline"></v-icon>
                    <v-list-item-content>New</v-list-item-content>
                  </v-list-item>
                  <v-list-item @click="onUploadWorkspace()">
                    <v-icon class="mr-2" v-text="icons.mdiUpload"></v-icon>
                    <v-list-item-content>Upload</v-list-item-content>
                  </v-list-item>
                </v-list>
              </v-menu>
          </v-card-title>
        </v-card>
      </v-col>
    </v-row>
    <WorkspaceSetup v-if="newWorkspaceWizard"
      v-on:onCreate="onWorkspaceCreate" v-on:onCancel="onWorkspaceCreateCancel" />
    
    <v-dialog v-model="renameDialog" persistent max-width="300">
      <v-card>
        <v-card-title class="headline">Rename</v-card-title>
        <v-card-text class="py-0 my-0">
          <v-text-field label="New name" v-model="workspaceNewName"></v-text-field>
        </v-card-text>
        <v-card-actions class="d-flex  justify-end  px-4 pb-4">
          <v-btn class="ma-2" @click="onWorkspaceRenameCancel()">Cancel</v-btn>
          <v-btn color="blue-grey" class="ma-2 white--text" @click="onWorkspaceRenameConfirm()">Rename</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="deleteConfirmDialog" persistent max-width="400">
      <v-card>
        <v-card-title class="headline">Delete</v-card-title>
        <v-card-text class="py-0 my-0">
          <v-alert dense text type="error">
            This operation is permanent. No recovery is possible afterwards. Confirm delete ? 
          </v-alert>
        </v-card-text>
        <v-card-actions class="d-flex  justify-end  px-4 pb-4">
          <v-btn class="ma-2" @click="onWorkspaceDeleteCancel()">Cancel</v-btn>
          <v-btn color="blue-grey" class="ma-2 white--text" @click="onWorkspaceDeleteConfirm()">Delete</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="importDialog" persistent max-width="400">
      <v-card>
        <v-card-title class="headline">Import</v-card-title>
        <v-card-text class="py-0 my-0">
          <v-row>
            <v-col class="d-flex">
              <v-file-input
                show-size
                accept="text/json, application/json"
                label="Select a file to upload"
                v-model="fileToUpload"
              ></v-file-input>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions class="d-flex  justify-end  px-4 pb-4">
          <v-btn class="ma-2" @click="onWorkspaceImportCancel()">Cancel</v-btn>
          <v-btn color="blue-grey" class="ma-2 white--text" @click="onWorkspaceImportConfirm()">Upload</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import WorkspaceSetup from "@/components/WorkspaceSetup.vue";
import { mdiDotsVertical, mdiDelete, mdiPencil, mdiDownload, mdiUpload, mdiFilePlusOutline } from "@mdi/js";

export default {
  components: {
    WorkspaceSetup
  },
  data: () => ({
    newWorkspaceWizard: false,
    icons: {mdiDotsVertical, mdiDownload, mdiDelete, mdiPencil, mdiUpload, mdiFilePlusOutline},
    imageComponent: undefined,
    workspaceToDelete:undefined,
    workspaceToRename:undefined,
    workspaceNewName:undefined,
    importDialog: false,
    fileToUpload:undefined,
  }),
  computed: {
    workspaces() {
      return this.$store.state.workspaces;
    },
    hasWorkspace() {
      return this.$store.state.workspaces.length > 0;
    },
    deleteConfirmDialog() {
      return this.workspaceToDelete !== undefined;
    },
    renameDialog() {
      return this.workspaceNewName !== undefined;
    }
  },
  methods: {
    onWorkspaceSelect(workspace) {
        this.$store.dispatch("setCurrentWorkspace", workspace);
    },
    onWorkspaceCreateCancel() {
      this.newWorkspaceWizard = false;
    },
    async onWorkspaceCreate(props) {
      await this.$store.dispatch("createWorkspace", props);
      this.newWorkspaceWizard = false;
    },
    onWorkspaceRename(workspace) {
      this.workspaceToRename = workspace;
      this.workspaceNewName = workspace.name;
    },
    async onWorkspaceRenameConfirm() {
      if (this.workspaceNewName && this.workspaceNewName !== this.workspaceToRename.name) {
        const wsJson = this.workspaceToRename.toJson();
        wsJson.name = this.workspaceNewName;
        await this.$store.dispatch("renameWorkspace", wsJson);
      }
      this.workspaceToRename = undefined;
      this.workspaceNewName = undefined;
    },
    onWorkspaceRenameCancel() {
      this.workspaceToRename = undefined;
      this.workspaceNewName = undefined;
    },
    async onWorkspaceDownload(workspace) {
      await this.$store.dispatch("downloadWorkspace", workspace);
    },
    onWorkspaceDelete(workspace) {
      this.workspaceToDelete = workspace;
    },
    async onWorkspaceDeleteConfirm() {
      await this.$store.dispatch("deleteWorkspace", this.workspaceToDelete);
      await this.$store.dispatch("getWorkspaces");
      this.workspaceToDelete = undefined;
    },
    onWorkspaceDeleteCancel() {
      this.workspaceToDelete = undefined;
    },
    onCreateNewWorkspace() {
      this.newWorkspaceWizard = true;
    },
    onUploadWorkspace() {
      this.importDialog = true;
      this.fileToUpload = undefined;
    },
    onWorkspaceImportCancel() {
      this.importDialog = false;
    },
    async onWorkspaceImportConfirm() {
      if (this.fileToUpload) {
        const content = await this.fileToUpload.text();
        const jsonContent = await new Promise(resolve => {
          resolve(JSON.parse(content));
        });
        await this.$store.dispatch("importWorkspace", jsonContent);
      }
      this.importDialog = false;
    }
  }
};
</script>

<style lang="scss" scoped>
</style>